module.exports = __webpack_public_path__ + "static/media/fitness_journal.b86ecc1f.svg";